angular.module('property-deal')
    .controller('PropertyDealBuyersController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal, User, GusService, ClientLead, ClientFinderService, PropertyDealBuyerMapper, Principal) {
        this.$onInit = () => {
            this.canWriteLeadClients = Principal.hasAnyAuthority(['ROLE_CLIENTS_WRITE', 'ROLE_CLIENTS_LEAD_WRITE'])
            this.form = {
                id: data.id,
                buyers: angular.copy(data.buyers)
            }
        }
        this.add = () => {
            this.form.buyers.push({
                type: 'RETAIL'
            })
        }
        this.gusUpdate = c => {
            this.isProcessing = true
            GusService.search(c.nip)
                .then(gus => {
                        this.isProcessing = false
                        toastr.success("Załadowano dane z: " + gus.details.nazwa)
                        c.nip = gus.nip
                        c.fullName = gus.details.nazwa
                        c.address = gus.details.adres
                        c.postcode = gus.details.kodPocztowy
                        c.city = gus.details.miasto
                        c.phone1 = c.phone1 || gus.details.numerTelefonu
                        c.email = c.email || gus.details.email
                    },
                    () => $ctrl.isProcessing = false)
        }
        this.onTypeChanged = (type, buyer) => {
            if (type !== 'COMPANY') {
                buyer.nip = null
            }
        }
        this.openClient = (clientId, c) => {
            if (!this.canWriteLeadClients) {
                return
            }
            ClientLead.get({id: clientId}).$promise.then((client) => {
                return ClientFinderService.edit(client).then(savedClient => this.onClientSelected(savedClient, c))
            })
        }
        this.onClientSelected = (client, c) => {
            PropertyDealBuyerMapper.applyClient(client, c)
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyDeal.buyersUpdate(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
